const initialState = {
  loading: false,
  charities: [],
  featuredCampaigns: [],
  pagination: {
    pageNumber: 1,
    pageSize: 9
  },
  filter: {
    name: ''
  }
};

const charityListings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_FOR_CHARITY_LISTINGS':
    case 'FOLLOW_COMPANY_CHARITY_REQUEST':
    case 'FOLLOW_COMPANY_CHARITY_SUCCESS':
    case 'FOLLOW_COMPANY_CHARITY_FAILED':
    case 'SET_PAGINATION_FOR_CHARITY_LISTINGS':
    case 'GET_CHARITY_LISTINGS_REQUEST':
    case 'GET_CHARITY_LISTINGS_SUCCESS':
    case 'GET_CHARITY_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_CHARITY_LISTINGS_REQUEST':
    case 'GET_FEATURED_CAMPAIGNS_FOR_CHARITY_LISTINGS_SUCCESS':
    case 'GET_FEATURED_CAMPAIGNS_FOR_CHARITY_LISTINGS_FAILED': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default charityListings;
